import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Chip,
  Grid,
  Stack,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import productTranssferService from "../../../services/productTransferService";
import { Info } from "@mui/icons-material";
import ProductTransferInfoModal from "../../UI/reusable-components/ProductPageComponents/ProductTransferInfoModal";

const PreviewProductSend = ({
  selectedProducts = [],
  selectedVariantProducts = [],
  marketPlaceName,
  selectedPlatform,
  selectedAttributes = [],
  loading,
  sendSelectedProductOutward,
  compleatedProduct,
  clearProduct,
  selectedPlatformType
}) => {
  const product = selectedProducts[0] || {};
  
  const {
    title: productTitle,
    productImages = [],
    category = {},
    brandId,
    stockCode,
    supplierBarcode,
    productMainId,
  } = product;

 const[productTransfreList , setProductTransfer]=useState(null)

  const productTransfer=async()=>{
    const mainProductId = selectedProducts[0].id;
  
   
    const variantIds = selectedVariantProducts.map(variant => variant.id);
    const allIds = [mainProductId, ...variantIds];
    var response=await productTranssferService.fetchProductPleaces(allIds,selectedPlatform,selectedPlatformType)
    setProductTransfer(response?.data?.data);

  }

  useEffect(()=>{
    productTransfer();
},[compleatedProduct]);
  return (
    <Box sx={{ p: 2 }}>
      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
          width="100%"
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <Typography variant="h5" gutterBottom>
            Ürün Ön İzleme
          </Typography>

          <Typography variant="body1" gutterBottom>
            Pazar Yeri: {marketPlaceName || "-"}
          </Typography>

          {/* Ana Ürün Tablosu */}
          <TableContainer component={Paper} sx={{ mb: 3 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Ana Ürün</TableCell>
                  <TableCell>Kategori</TableCell>
                  <TableCell>Stok Kodu</TableCell>
                  <TableCell>Tedarikçi Barkod</TableCell>
                  <TableCell>İşlemler</TableCell>

                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Stack direction="row" alignItems="center" spacing={2}>
                      {productImages.length > 0 && (
                        <Box
                          component="img"
                          src={productImages[0].imageUrl}
                          alt={productTitle}
                          sx={{ width: 50, height: 50, objectFit: "contain" }}
                        />
                      )}
                      <Typography variant="body2">{productTitle || "-"}</Typography>
                    </Stack>
                  </TableCell>
                  <TableCell>{category.name || "-"}</TableCell>
                  <TableCell>{stockCode || "-"}</TableCell>
                  <TableCell>{supplierBarcode || "-"}</TableCell>
                  <TableCell>
                    <Button
                      onClick={() => sendSelectedProductOutward(product.id)}
                      variant="contained"
                      color="primary"
                      disabled={
                        productTransfreList?.some((item) => item?.productId === product?.id)||selectedPlatformType=="ecommerce"
                      }
                      sx={{
                        borderRadius: 2
                      }}
                    >
                      Gönder
                    </Button>
                  </TableCell>

                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          {/* Varyant Ürünler Tablosu */}
          <Typography variant="h6" gutterBottom>
            Varyant Ürünler
          </Typography>
          {selectedVariantProducts.length > 0 ? (
            <TableContainer component={Paper} sx={{ mb: 3 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Görsel</TableCell>
                    <TableCell>Başlık</TableCell>
                    <TableCell>Kategori</TableCell>
                    <TableCell>Stok Kodu</TableCell>
                    <TableCell>Tedarikçi Barkod</TableCell>
                    <TableCell>İşlemler</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedVariantProducts.map((variant, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {variant.productImages && variant.productImages.length > 0 ? (
                          <Box
                            component="img"
                            src={variant.productImages[0].imageUrl}
                            alt={variant.title}
                            sx={{ width: 50, height: 50, objectFit: "contain" }}
                          />
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell>{variant.title || "-"}</TableCell>
                      <TableCell>{category.name || "-"}</TableCell>
                      <TableCell>{variant.stockCode || "-"}</TableCell>
                      <TableCell>{variant.supplierBarcode || "-"}</TableCell>
                      <TableCell>
                        <Button
                          onClick={() => sendSelectedProductOutward(variant.id)}
                          variant="contained"
                          color="primary"
                          disabled={
                            productTransfreList?.some((item) => item?.productId === variant?.id)||selectedPlatformType=="ecommerce"
                          }
                          sx={{
                            borderRadius: 2
                          }}
                        >
                          Gönder
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography variant="body2" sx={{ mb: 3 }}>
              Varyant ürün bulunmamaktadır.
            </Typography>
          )}

          {/* Seçili Özellikler */}
          {selectedAttributes.length > 0 && (
            <Box>
              <Typography variant="h6" gutterBottom>
                Seçili Özellikler
              </Typography>
              <Stack direction="row" spacing={1} flexWrap="wrap">
                {selectedAttributes.map((attr, index) => (
                  <Chip
                    key={index}
                    label={`${attr.attribute.name}: ${attr.value.name==null?attr.value:attr.value.name}`}
                    variant="outlined"
                    size="small"
                  />
                ))}
              </Stack>
            </Box>
          )}
           {/* <Stack direction="row" justifyContent="flex-end">
            <Button
              onClick={clearProduct}
              variant="contained"
              color="primary"
              sx={{
                borderRadius: 2
              }}
            >
              Bitir
            </Button>
          </Stack> */}


        </Box>
      )}
    </Box>
  );
};

export default PreviewProductSend;